import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconArrowLeft$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArrowLeft extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'be500a8e0f42c324f0e1b2d0d484a9c42e01ea36', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5b5855aa5930eeeee63362cbd7727fe4c070c1a4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '23bcd509944d884fed62b6d3d8e274d2ae7b2704', d: "m6.718 11.75 3.145 3.145a.5.5 0 0 1 0 .707l-.353.354a.5.5 0 0 1-.707 0L4.207 11.36a.5.5 0 0 1-.147-.357c0-.129.048-.258.147-.356L8.803 6.05a.5.5 0 0 1 .707 0l.353.354a.5.5 0 0 1 0 .707l-3.139 3.14h10.718a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-arrow-left", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-arrow-left"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-arrow-left":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArrowLeft$1);
            }
            break;
    } });
}

const CosmosIconArrowLeft = CosmosIconArrowLeft$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArrowLeft, defineCustomElement };
